export const ssnMask = 'AAA-AA-0000';
